import en from "./en";
import uk from "./uk";
import ru from "./ru";

import store from "@/store";
const messages = {
  en,
  uk,
  ru,
};
// Russian is switched off (23.09.2026): the whole platform works in Ukrainian
const defaultLanguage = "uk";

store.dispatch("app/setDefaultLocale", defaultLanguage);

export { messages, defaultLanguage };
